<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterLinkGroup
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3960-5384
 *
 * A titled group inside the footer: Title/M inverse heading over the default slot.
 * layout=list stacks children vertically (FooterLink rows carry their own rhythm);
 * layout=row lays them out as a wrapping horizontal strip (badge/social rows).
 * No surface of its own — it shows the footer's dark surface through. The content
 * gap is exposed as --footer-link-group-gap (default space/6): the "Follow us" row
 * sets it to 0 because SocialButton carries its spacing inside its own 44px box.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { FooterLinkGroupProps } from '../types/interfaces'

defineOptions({
  name: 'FooterLinkGroup',
})

withDefaults(defineProps<FooterLinkGroupProps>(), {
  layout: 'list',
})
</script>

<template>
  <div class="footer-link-group">
    <p class="footer-link-group__title btly-text-title-m">{{ title }}</p>
    <div
      class="footer-link-group__content"
      :class="`footer-link-group__content--${layout}`"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_footer-link-group.scss" />
